import { gql } from '@apollo/client'

import COLLECTION_FRAGMENT from '../../components/CourseCollectionCard/fragments'

export const COLLECTIONS = gql`
  query Collections_collections($page: Int, $perPage: Int, $productCourseId: ID) {
    productCollections(page: $page, perPage: $perPage, productCourseId: $productCourseId) {
      nodes {
        ...CourseCollectionCardComponent
      }
      totalCount
      pageInfo {
        hasNextPage
        totalCount
      }
    }
  }
  ${COLLECTION_FRAGMENT}
`

export default gql`
  query Collections {
    productCollections(perPage: 100) {
      nodes {
        variants {
          nodes {
            product {
              ... on ProductCourse {
                id
                title
              }
            }
          }
        }
      }
    }
  }
`
